<template>
  <div class="point-page">
    <div class="well_box">
      <p class="sub_title img">
        Basic Information
        <img
          v-if="['OIL', 'ALL'].includes(this.pageData.type)"
          src="@/assets/image/well/oil.png"
          alt=""
          srcset=""
          style="width: 0.66rem; height: 0.24rem; margin-left: 0.15rem"
        />
        <img
          v-if="['GAS', 'ALL'].includes(this.pageData.type)"
          src="@/assets/image/well/gas.png"
          alt=""
          srcset=""
          style="width: 0.66rem; height: 0.24rem; margin-left: 0.15rem"
        />
      </p>
      <el-form
        class="page-form point-form"
        ref="addWellForm"
        :model="pageData"
        label-position="left"
      >
        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="Unique ID:">
              <account :value="uniqueId" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="nickname" label="Well Name:">
              {{ pageData.nickname }}
            </el-form-item>
          </el-col>
          <el-col :span="24"></el-col>
          <el-col :span="12">
            <el-form-item prop="UWI" label="AER UWI:">
              <div v-if="pageData.status === 1" class="tip_box">
                <el-tooltip placement="top" content="The value is encrypted.">
                  <svg-icon
                    icon-class="ts"
                    class="tip_btn"
                    style="left: 0.78rem"
                  ></svg-icon>
                </el-tooltip>
                <account :value="pageData.UWI" class="tip_val" />
              </div>
              <span v-else>{{ pageData.UWI }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="fromToIDIdentifier" label="FromToIDIdentifier:">
              <div v-if="pageData.status === 1" class="tip_box">
                <el-tooltip placement="top" content="The value is encrypted.">
                  <svg-icon
                    icon-class="ts"
                    class="tip_btn"
                    style="left: 1.56rem"
                  ></svg-icon>
                </el-tooltip>
                <account :value="pageData.fromToIDIdentifier" class="tip_val" />
              </div>
              <span v-else>{{ pageData.fromToIDIdentifier }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24"></el-col>
          <el-col :span="12" v-if="pageData.type === 'OIL'">
            <el-form-item prop="sulphur" label="Sulphur Content:">
              {{ pageData.sulphur }} %
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="pageData.type === 'OIL'">
            <el-form-item prop="APIGravity" label="API Gravity:">
              {{ pageData.APIGravity }}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="pageData.type === 'OIL' && pageData.oilAnalysis">
            <el-form-item prop="oilAnalysis" label="Oil Analysis:">
              <el-button type="text" @click="openPdfView('oilAnalysis')">
                {{ pageData.oilAnalysis }}
              </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="pageData.wellLisence">
            <el-form-item prop="wellLisence" label="Well Licence:">
              <el-button type="text" @click="openPdfView('wellLisence')">
                {{ pageData.wellLisence }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="sub_title">
        <div>
          Beneficiary Information
          <el-tooltip placement="top">
            <div slot="content">
              1. Please ensure that the beneficiary's account is true, accurate, and
              carefully distributed;<br />2. After the Rep is minted successfully, it will
              be automatically sent to the beneficiary's account according to the ratio
              you set.
            </div>
            <svg-icon icon-class="ts"></svg-icon>
          </el-tooltip>
        </div>
      </div>
      <el-table :data="pageData.beneficiaries">
        <el-table-column label="No." align="center" width="150">
          <template slot-scope="scope">
            <svg-icon icon-class="share_user" v-if="isOwner(scope.row)"></svg-icon>
            {{ scope.$index + 1 }}
            <span v-if="isOwner(scope.row)">(YOU)</span>
          </template>
        </el-table-column>
        <el-table-column prop="tnEthAccount" label="Beneficiar"> </el-table-column>
        <el-table-column prop="ratio" label="Benefit ratio" width="200">
          <template slot-scope="{ row }"> {{ row.ratio }}% </template>
        </el-table-column>
      </el-table>
    </div>
    <pdfView ref="pdfView" />
  </div>
</template>

<script>
import pdfView from "@/components/PdfView/index.vue";
export default {
  props: {
    pageData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pointForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: { pdfView },
  data() {
    return {
      uniqueId: "",
    };
  },
  watch: {
    pageData: {
      immediate: true,
      deep: true,
      handler(obj) {
        if (obj.wellID) {
          this.uniqueId = web3.utils.padRight(web3.utils.toHex(obj.wellID), 64);
        }
      },
    },
  },
  methods: {
    isOwner(row) {
      let val = row.tnEthAccount || row.address;
      return val === this.$store.getters.metaMaskObj.account;
    },
    openPdfView(name) {
      this.$refs.pdfView.open({
        name: this.pageData[name],
      });
    },
  },
};
</script>
<style scoped lang="scss">
.point-page {
  .top_form {
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 0.2rem 0.24rem;
  }
  .sub_title {
    font-size: 0.18rem;
    font-family: Roboto-Bold, Roboto;
    font-weight: bold;
    color: #000000;
    line-height: 0.28rem;
    margin-bottom: 0.16rem;
    display: flex;
    justify-content: space-between;
  }

  .sub_title.img {
    justify-content: flex-start;
  }

  .well_box {
    background-color: #fafafa;
    padding: 0.24rem 0.32rem;
    box-sizing: border-box;
  }
}

.tip_box {
  position: relative;
  .tip_btn {
    position: absolute;
  }
  .tip_val{
    margin-left: 0.14rem;
  }
}
</style>
